import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { authAPI } from '../../services/api'
import { useAuth } from '../../contexts/AuthContext'
import { t, getLanguage, STORAGE_KEYS } from '../../i18n'

// Lands here from the main domain right after signing in: the one-time code
// in the URL fragment opens the same session on this store's subdomain.
export default function SsoPage() {
  const navigate = useNavigate()
  const { adoptSession } = useAuth()
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    const params = new URLSearchParams(window.location.hash.slice(1))
    const code = params.get('code')
    // The dashboard language from the main domain (this address has its own storage).
    const lang = ['ar', 'en'].includes(params.get('lang')) ? params.get('lang') : null
    if (lang) { try { localStorage.setItem(STORAGE_KEYS.admin, lang) } catch { /* storage unavailable */ } }
    // Drop the code from the address bar and history straight away.
    window.history.replaceState(null, '', window.location.pathname)
    if (!code) {
      navigate('/admin/login', { replace: true })
      return
    }
    authAPI.redeemHandoff(code)
      .then(({ data }) => {
        adoptSession(data)
        // A different language needs a fresh load to switch the whole admin.
        if (lang && lang !== getLanguage()) window.location.replace(data.next || '/admin/dashboard')
        else navigate(data.next || '/admin/dashboard', { replace: true })
      })
      .catch(() => {
        toast.error(t('Sign-in link is invalid or expired'))
        navigate('/admin/login', { replace: true })
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="loading-spinner mx-auto mb-4"></div>
        <p className="text-gray-600">{t('Opening your store…')}</p>
      </div>
    </div>
  )
}
